import React, { createContext, useState, useEffect, useContext } from "react";
import {
  getAuth,
  GoogleAuthProvider,
  GithubAuthProvider,
  onAuthStateChanged,
} from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getFirestore, doc, getDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBdvQQCKgrnIiCiHxsElZczU1DDIj0XGkc",
  authDomain: "security-plus-crammer.firebaseapp.com",
  projectId: "security-plus-crammer",
  storageBucket: "security-plus-crammer.firebasestorage.app",
  messagingSenderId: "513793333963",
  appId: "1:513793333963:web:e33171e31ae0e37dbc994e",
  measurementId: "G-RKY3P28TR1",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const githubProvider = new GithubAuthProvider();
export const db = getFirestore(app);

// Create context
export const AuthContext = createContext();

// Custom hook for using auth
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isPaidUser, setIsPaidUser] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          await user.getIdToken(true);
          const idTokenResult = await user.getIdTokenResult();
          user.customClaims = idTokenResult.claims;

          // Check payment status from custom claims OR Firestore
          const userRef = doc(db, "users", user.uid);
          const docSnap = await getDoc(userRef);
          const paid =
            idTokenResult.claims.isPaid === true ||
            (docSnap.exists() && docSnap.data().isPaidUser === true);
          setIsPaidUser(paid);
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      } else {
        setIsPaidUser(false);
      }

      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const value = {
    user,
    isPaidUser,
    loading,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
